<template>
  <AppPageContainer :showNav="true">
    <ELYXLandingContainer>
      <div class="pricing">
        <div class="pricing__header">
          <h1 class="pricing__title">Break up with procrastination</h1>
          <p class="pricing__description">Get insanely productive for less than the price of a Starbucks!</p>
        </div>
        <div class="pricing-switcher pricing__tabs">
          <div class="pricing__tabs--highlight">Best Value</div>
          <!-- <div class="pricing__tabs--highlight middle-highlight">Save 16%</div> -->
          <div class="fieldset pricing__tabs--sections">
            <input
              type="radio"
              name="group-a"
              value="monthly"
              v-model="selectedTab"
              id="monthly-1"
              :checked="selectedTab === 'monthly'"
              @change="updateSelectionIndicator(0)"
            />
            <label for="monthly-1">Monthly</label>
            <input
              type="radio"
              name="group-a"
              value="annual"
              v-model="selectedTab"
              id="annual-1"
              :checked="selectedTab === 'annual'"
              @change="updateSelectionIndicator(1)"
            />
            <label for="annual-1"> Yearly </label>
            <input
              type="radio"
              name="group-a"
              value="lifetime"
              v-model="selectedTab"
              id="lifetime-1"
              :checked="selectedTab === 'lifetime'"
              @change="updateSelectionIndicator(2)"
            />
            <label for="lifetime-1"> Lifetime </label>
            <span class="pricing__tab--selection"></span>
          </div>
        </div>
        <!--  <div class="pricing__tabs">
        <div class="pricing__tab--selection"></div>
        <div class="pricing__tab">
          <div class="pricing__tab--option">Yearly</div>
          <div class="pricing__tab--discount">Save 20%</div>
        </div>
        <div class="pricing__tab">
          <div class="pricing__tab--option">Monthly</div>
        </div>
      </div> -->
        <div class="pricing__options">
          <div class="pricing__option">
            <div class="pricing__option--offer">
              <div class="pricing__option--header">
                <h2 class="pricing__option--title">Starter</h2>
              </div>
              <div class="pricing__option--price">
                <div class="pricing__option--price--tag">Free</div>
              </div>
              <p class="pricing__option--description">3 sessions a week</p>
            </div>
            <div class="pricing__option--footer">
              <ELYXButton class="pricing__option--free" @click="goToRegisterPage('free')">Get started</ELYXButton>
              <div class="pricing__option--disclaimer">No credit card required.</div>
            </div>
          </div>
          <div class="pricing__option">
            <div class="pricing__option--offer">
              <div class="pricing__option--header">
                <h2 class="pricing__option--title">Premium ✨</h2>
              </div>
              <div class="pricing__option--price">
                <div class="pricing__option--price--tag">{{ getPrice }}</div>
                <div class="pricing__option--price--period">{{ getPeriod }}</div>
              </div>
              <p class="pricing__option--description">Unlimited sessions</p>
            </div>
            <div class="pricing__option--footer">
              <ELYXButton @click="goToRegisterPage('pro')">Join for free</ELYXButton>
              <div class="pricing__option--disclaimer">Start free, upgrade when ready.</div>
            </div>
          </div>
          <!-- <div class="pricing__option">
          <div class="pricing__option-header">
            <h2 class="pricing__option-title">Yearly</h2>
            <p class="pricing__option-description">For the power user</p>
          </div>
          <div class="pricing__option--price">
            <div class="pricing__option--price--tag">$49.99</div>
            <div class="pricing__option--price--period">/year</div>
          </div>
          <div class="pricing__option-features">
            <ul class="pricing__option-features-list">
              <li class="pricing__option-feature">Unlimited sessions</li>
              <li class="pricing__option-feature">Up to 10 participants</li>
              <li class="pricing__option-feature">Up to 10 hours per session</li>
              <li class="pricing__option-feature">Public and private sessions</li>
              <li class="pricing__option-feature">Priority support</li>
            </ul>
          </div>
          <div class="pricing__option-footer">
            <ELYXButton>Try for free</ELYXButton>
          </div>
        </div> -->
          <!-- <div class="pricing__option">
          <div class="pricing__option-header">
            <h2 class="pricing__option-title">Lifetime</h2>
            <p class="pricing__option-description">For the power user</p>
          </div>
          <div class="pricing__option--price">
            <div class="pricing__option--price--tag">$89.99</div>
          </div>
          <div class="pricing__option-features">
            <ul class="pricing__option-features-list">
              <li class="pricing__option-feature">Unlimited sessions</li>
              <li class="pricing__option-feature">Up to 10 participants</li>
              <li class="pricing__option-feature">Up to 10 hours per session</li>
              <li class="pricing__option-feature">Public and private sessions</li>
              <li class="pricing__option-feature">Priority support</li>
            </ul>
          </div>
          <div class="pricing__option-footer">
            <ELYXButton>Try for free</ELYXButton>
          </div>
        </div> -->
        </div>
      </div>
      <!-- <div class="pricing__faq">
      <div>You're in great company</div>
      <div>Join users from some of the best universities and organizations in the world</div>
      <div class="pricing__socialproof">
        <div class="pricing__socialproof--org">University of Toronto</div>
        <div class="pricing__socialproof--org">YCombinator</div>
        <div class="pricing__socialproof--org">Oxford</div>
        <div class="pricing__socialproof--org">IBM</div>
      </div>
    </div> -->
      <ELYXFAQ :questions="questions" />

      <ELYXFooterCTAShort headline="Your best work starts here." />
    </ELYXLandingContainer>
    <Footer :footerColor="'transparent'" />
  </AppPageContainer>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer.vue";
import Footer from "./Sections/Footer.vue";
import ELYXLandingContainer from "../../ELYXComponents/ELYXLandingContainer.vue";
import ELYXButton from "../../ELYXComponents/ELYXButton.vue";
import ELYXFAQ from "../../ELYXComponents/ELYXFAQ.vue";
import ELYXFooterCTAShort from "../../ELYXComponents/ELYXFooterCTAShort.vue";

export default {
  title: "Pricing | Cofocus",
  components: {
    AppPageContainer,
    Footer,
    ELYXLandingContainer,
    ELYXButton,
    ELYXFAQ,
    ELYXFooterCTAShort,
  },
  data() {
    return {
      hue: 0,
      intervalId: null,
      selectedTab: "monthly",
      questions: [
        {
          question: "Why should I pay for Cofocus?",
          answer:
            "Hosting video calls comes with huge expenses. As Cofocus is entirely funded by your subscriptions (we don't have outside funding, we don't sell data, we don't have ads), then it's the only way to keep the platform running. Additionally, Cofocus is designed, developed and maintained by a small passionate, two-person team. Your support allows us to keep working on this full-time. For a price that costs less than a Starbucks, think of it as an investment in your future. In other words, how much is being more productive worth to you?",
        },
        {
          question: "Who is behind Cofocus?",
          answer:
            "Cofocus is built by a small, passionate two-person team based in Europe: Robert, who takes care of everything technical, and Ness, who makes sure you find out about us in the first place!",
        },
        {
          question: "Do you offer price localization / purchasing parity?",
          answer:
            "Hosting video calls costs the same regardless of location (and sometimes even more), and as a small independent company, we're unfortunately unable to offer localized pricing at this time. However as we grow and become larger, we will definitely look into supporting this as we can appreciate the huge difference this can make!",
        },
        {
          question: "What payment methods do you support?",
          answer:
            "Our payments are powered by Stripe, which means we accept all major credit cards, along with many other localized payment options. We also support PayPal.",
        },
        /*         {
          question: "Do you offer refunds?",
          answer: "For more information, please refer to our Cancellation and Refund Policy.",
        }, */
        {
          question: "Where is your company based?",
          answer: "Our company, ElysiumOne OÜ, is based in Tallinn, Estonia (Europe), as is our team.",
        },
      ],
      selectedQuestionIndex: null,
    };
  },
  mounted() {
    this.intervalId = setInterval(this.updateHue, 250); // Change hue every 150ms
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    getPrice() {
      switch (this.selectedTab) {
        case "monthly":
          return "$4.99";
        case "annual":
          return "$49.99";
        case "lifetime":
          return "$89.99";
        default:
          return "???";
      }
    },
    getPeriod() {
      switch (this.selectedTab) {
        case "monthly":
          return "/ month";
        case "annual":
          return "/ year";
        case "lifetime":
          return "";
        default:
          return "/ ???";
      }
    },
    gradientStyle() {
      return {
        background: `linear-gradient(197deg,
          ${this.calculateColor(this.hue, 0, 100)} 0%,
          ${this.calculateColor(this.hue, 100, 89)} 100%)`,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "background 0.15s linear",
      };
    },
  },
  methods: {
    goToRegisterPage(fromWhere) {
      window.mixpanel.track(`Sign Up via Pricing Page (${fromWhere} plan button)`);
      window.location = "/account/register";
    },
    updateSelectionIndicator(index) {
      const selectedLabel = this.$el.querySelectorAll(".pricing__tabs label")[index];
      const labelWidth = selectedLabel.offsetWidth;
      const requiredTranslation = index * labelWidth;

      const selectionIndicator = this.$el.querySelector(".pricing__tab--selection");
      selectionIndicator.style.transform = `translateX(${requiredTranslation}px)`;
    },
    openQuestion(index) {
      if (this.selectedQuestionIndex === index) {
        this.selectedQuestionIndex = null;
      } else {
        this.selectedQuestionIndex = index;
      }
    },
    calculateColor(h, s, l) {
      const hueValue = (h + 197) % 360; // Add 197 to match the original gradient's angle
      return `hsl(${hueValue}, ${s}%, ${l}%)`;
    },
    updateHue() {
      this.hue = (this.hue + 1) % 360;
    },
  },
};
</script>

<style>
.pricing {
  /*   background: url(https://ik.imagekit.io/elysiumone/Official/100-100-5_dfeQOUA1S.png?updatedAt=1715271894398),
    linear-gradient(251deg, rgb(255 255 255) 11%, rgb(247 251 255) 35%, rgb(255 255 255) 100%); */
  padding: 10rem 5rem;
}
.pricing__option--offer {
  margin-bottom: 25px;
}
.pricing__header {
  margin-bottom: 65px;
}
.pricing__title {
  text-align: center;
  font-size: 60px;
  font-weight: 400;
  line-height: 120%;
}
.pricing__description {
  text-align: center;
  font-size: 24px;
  line-height: 35px;
  max-width: 42rem;
  margin: 0px auto;
  margin-top: 10px;
  font-weight: 300;
}
.pricing__options {
  display: flex;
  justify-content: center;
}
.pricing__option {
  padding: 18px;
  margin: 0px 10px;
  border: 1px solid transparent;
  border-radius: 25px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: #ffffff9c !important;
  width: 330px;
  position: relative;
  backdrop-filter: blur(5px);
  box-sizing: border-box;
}
.pricing__option--header {
  margin-bottom: 10px;
}
.pricing__option--title {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 5px;
}
.pricing__option--description {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 17px;
}
.pricing__option--price {
  display: flex;
  align-items: baseline;
}
.pricing__option--price--tag {
  font-size: 28px;
  font-weight: 400;
}
.pricing__option--price--period {
  margin-left: 5px;
}
.pricing__option--disclaimer {
  text-align: center;
  margin-top: 10px;
  color: #555;
  font-size: 15px;
}
.pricing__tab--discount {
  margin-left: 5px;
}
.pricing__option--free button {
  background: white;
  color: black;
  border: 1px solid;
}
.pricing__option--free button:hover {
  background-color: #f3f3f3;
}

.pricing__tabs {
  display: flex;
  padding: 0px;
  margin: 0px auto;
  border: 1px solid transparent;
  border-radius: 360px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: #ffffff5c !important;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 60px;
  position: relative;
  text-align: center;
  justify-content: center;
  box-sizing: border-box;
}
.pricing__tabs--sections {
  display: inline-block;
  position: relative;
  padding: 4px;
  border-radius: 50em;
}
.pricing__tabs input[type="radio"] {
  position: absolute;
  opacity: 0;
}
.pricing__tabs label {
  position: relative;
  z-index: 1;
  display: inline-block;
  float: left;
  width: 125px;
  height: 35px;
  line-height: 35px;
  cursor: pointer;
  color: #000000;
  text-decoration: none;
  font-weight: 400;
  transition-delay: 0.1s;
  transition: color 0.3s ease;
}
.pricing__tabs input[type="radio"]:checked + label {
  color: black;
  text-decoration: none;
  font-weight: 500;
}
.pricing__tab--selection {
  /* floating background */
  position: absolute;
  top: 3px;
  left: 4px;
  height: 35px;
  width: 125px;
  transition: transform 0.3s;
  border: 1px solid transparent;
  border-radius: 360px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: #ffffff8a !important;
}
.pricing__tabs input[type="radio"]:checked + label + .pricing__tab--selection,
.pricing__tabs input[type="radio"]:checked + label:nth-of-type(n) + .pricing__tab--selection {
  /* use label:nth-of-type(n) to fix a bug on safari with multiple adjacent-sibling selectors*/
  transform: translateX(125px);
}
.pricing__tabs--highlight {
  position: absolute;
  right: -30px;
  top: -5px;
  font-size: smaller;
  font-weight: 500;
  transform: rotate(20deg);
  color: #282c30;
  padding: 3px 5px;
  z-index: 1;
  border-radius: 360px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background: #eff3ff;
}
.middle-highlight {
  right: 40%;
  transform: rotate(0deg);
  top: 35px;
  background-color: #762bff;
}
@media (max-width: 900px) {
  .pricing {
    padding: 6rem 2rem;
  }
}
@media (max-width: 600px) {
  .pricing {
    padding: 6rem 1rem;
  }
  .pricing__header {
    margin-bottom: 45px;
  }
  .pricing__title {
    font-size: 50px;
  }
  .pricing__description {
    font-size: 18px;
    font-weight: 300;
  }
  .pricing__tabs {
    margin-bottom: 30px;
    width: 100%;
  }
  .pricing__tabs label {
    width: 100%;
    font-size: 15px;
    text-align: center;
  }
  .pricing__tabs--sections {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .pricing__tab--selection {
    width: 33.333%;
    left: 3px;
  }
  .pricing__tabs--highlight {
    font-size: 12px;
    right: -28px;
  }
  .middle-highlight {
    right: 38.5%;
  }
  .pricing__options {
    flex-direction: column;
  }
  .pricing__option {
    margin: 0 auto;
    width: 100%;
  }
  .pricing__option:first-child {
    margin-bottom: 20px !important;
  }
}
@media (max-width: 375px) {
  .pricing {
    padding: 5rem 1rem;
  }
  .pricing__title {
    font-size: 40px;
  }
  .pricing__description {
    font-size: 17px;
    line-height: 30px;
  }
  .pricing__tabs label {
    font-size: 14px;
    text-align: center;
  }
}
</style>
